import {getCookie, setCookie} from "@js/globalFunctions/cookieHandling";
import {isJsonString} from "@js/globalFunctions/isJsonString";
export function buildHistoryPoint(url){
    setShortLastUrl(url);
    let currentHistory = getCookie('hipo');

    if(typeof currentHistory === 'undefined' || !isJsonString(currentHistory)){
        currentHistory = new Array();
        currentHistory.push(url);
    }else{
        currentHistory = JSON.parse(currentHistory);
        if(currentHistory[0] != url){
            currentHistory.unshift(url);
            if (currentHistory.length > 20) {
                currentHistory.splice(20);
            }
        }
        if(typeof currentHistory[1] !== 'undefined'){
            dataholder.shortLastUrl = setShortLastUrl(currentHistory[1]);
        }
    }
    dataholder.localHistory = currentHistory;
    const data = JSON.stringify(currentHistory);
    setCookie('hipo',data,24*30);
}

function setShortLastUrl(url){
    if(url.indexOf('/sommerhus-') !== -1 || url.indexOf('/ferienhaus-') !== -1){
        var urlParts = url.split('/');
        var urlId = false;
        for(var i = 0; i < urlParts.length; i++){
            if(urlParts[i].indexOf('sommerhus-') !== -1 || urlParts[i].indexOf('ferienhaus-') !== -1){
                urlId = urlParts[i];
                break;
            }
        }
        return urlId;
    }else{
        return false;
    }

}
